import { observer } from 'mobx-react-lite'
import { capitalizeFirstLetter } from '@/utils/string-util'
import { type WorkspacePostingItemViewModel } from '@/features/admin/staffing/WorkspacePostingItemViewModel'
import { type ColumnId } from '@/features/admin/staffing/components/StaffingTable/staffing-table-columns'
import { StaffingTableRow } from '@/features/admin/staffing/components/StaffingTableRow'
import {
  formatOpportunityType,
  formatWorkspacePostingStatus,
  workspacePostingStatusVariant,
} from '@/features/admin/staffing/workspace-posting-formatters'

export interface StaffingTableRowContainerProps {
  vm: WorkspacePostingItemViewModel
  columnIds: ColumnId[]
}

export const StaffingTableRowContainer = observer(
  function StaffingTableRowContainer({
    vm,
    columnIds,
  }: StaffingTableRowContainerProps) {
    const workspacePosting = vm.workspacePosting
    return (
      <StaffingTableRow
        columnIds={columnIds}
        id={workspacePosting.id}
        onPress={vm.select}
        isSelected={vm.isSelected}
        onToggleSelected={vm.toggleSelected}
        workspaceName={workspacePosting.workspace.name}
        workspaceIcon={workspacePosting.workspace.branding.logos.icon}
        opportunityTypeTitle={formatOpportunityType(
          workspacePosting.opportunityType,
        )}
        location={workspacePosting.location}
        primarySoftware={workspacePosting.primarySoftware}
        backupFileNeeded={workspacePosting.backupFileNeeded}
        supplementalSoftware={workspacePosting.supplementalSoftware}
        specialtiesText={workspacePosting.specialties.join(', ')}
        typeOfWorkText={workspacePosting.jobTypes
          .map((type) => capitalizeFirstLetter(type))
          .join(', ')}
        capacity={workspacePosting.capacity}
        maxAllowedWorkspaces={workspacePosting.maxAllowedWorkspaces}
        displayStatus={formatWorkspacePostingStatus(workspacePosting.status)}
        statusVariant={workspacePostingStatusVariant(workspacePosting.status)}
      />
    )
  },
)
